/**
 * Help-center article index. Each article is a JS module exporting
 * { slug, title, section, body } where body is the markdown subset
 * renderMarkdown.js supports. Keep bodies task-oriented and under
 * ~150 lines; operator-agnostic ALWAYS (the CI guard scans this).
 */

import gettingStarted from './getting-started';
import moveIn from './move-in';
import payments from './payments';
import invoices from './invoices';
import moveOut from './move-out';
import transfers from './transfers';
import paymentPlans from './payment-plans';
import rateChanges from './rate-changes';
import waitlist from './waitlist';
import dailyClose from './daily-close';
import exportsArticle from './exports';
import gateCodes from './gate-codes';
import tenantPortal from './tenant-portal';
import collections from './collections';

const articles = [
  gettingStarted,
  moveIn,
  payments,
  invoices,
  moveOut,
  transfers,
  paymentPlans,
  rateChanges,
  waitlist,
  collections,
  dailyClose,
  exportsArticle,
  gateCodes,
  tenantPortal,
];

export default articles;
export const articleBySlug = (slug) => articles.find((a) => a.slug === slug) || null;
